module.exports = __webpack_public_path__ + "assets/img/simply-Brand_05.f584e865.png";